import { HeaderDrawerItems } from "./HeaderDrawerItems";
import { BottomDrawerItems } from "./BottomDrawerItems";
import { MainDrawerItems } from "./MainDrawerItems";

export default {
  HeaderDrawerItems,
  BottomDrawerItems,
  MainDrawerItems
}